module.exports = __webpack_public_path__ + "static/media/deal2.a9633900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deal2.png
// module id = 19
// module chunks = 0